/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

/**
 * @description Bulk fetch v2 response with projected items keyed by ID
 */
export const bulkFetchV2ResponseSchema = z
  .object({
    itemsById: z
      .object({})
      .catchall(z.object({}).catchall(z.any()))
      .describe(
        'Map of item ID (as string) to projected field map. Each entry contains only the requested fields plus `id`.',
      ),
  })
  .describe('Bulk fetch v2 response with projected items keyed by ID');
